'use strict';

require('../../../../../result-list');

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _getEventsResultsForParticipant = require('ifeis-isomorphic/lib/redux/actions/events/getEventsResultsForParticipant');

var _getEventsResultsForParticipant2 = _interopRequireDefault(_getEventsResultsForParticipant);

var _accounts = require('ifeis-isomorphic/lib/redux/actions/accounts');

var _mapStateToController = require('./mapStateToController');

var _mapStateToController2 = _interopRequireDefault(_mapStateToController);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ResultsForPersonController = function ResultsForPersonController(feis, msgService, $ngRedux, $stateParams) {
  _classCallCheck(this, ResultsForPersonController);

  this.feis = feis;
  this._ = {
    msgService: msgService
  };

  this.loading = true;
  $ngRedux.dispatch((0, _accounts.getPerson)($stateParams.pid));
  $ngRedux.dispatch((0, _getEventsResultsForParticipant2.default)(this.feis.id, $stateParams.pid));

  $ngRedux.connect((0, _mapStateToController2.default)(this.feis.id, $stateParams.pid))(this);
};

angular.module('ifeis.routes.feiseanna.one.resultsForPerson', ['ngMaterial', 'ui.router', 'ifeis.feiseanna', 'ifeis.results-list']).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.resultsForPerson', {
    url: '/results/:pid',
    template: require('./tpl.html'),
    controller: ResultsForPersonController,
    controllerAs: 'results',
    ncyBreadcrumb: {
      label: '{{ results.person.get("fname") }} {{ results.person.get("lname") }}',
      parent: 'feiseanna.one.results'
    }
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/results/for-person/index.js
// module id = 594
// module chunks = 0